import { SVGProps } from "react";

const EmptyCheck = ({
  color,
  height,
  width,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12C3 7.28595 3 4.92893 4.46447 3.46447C5.92893 2 8.28595 2 13 2C17.714 2 20.0711 2 21.5355 3.46447C23 4.92893 23 7.28595 23 12C23 16.714 23 19.0711 21.5355 20.5355C20.0711 22 17.714 22 13 22C8.28595 22 5.92893 22 4.46447 20.5355C3 19.0711 3 16.714 3 12Z"
        fill={color ?? "white"}
        stroke="#E7EDF7"
        strokeWidth="1.4"
      />
    </svg>
  );
};

export default EmptyCheck;
